import PropTypes from 'prop-types';
import React, {Component} from 'react';

import LabeledInput from '../../components/forms/LabeledInput'
import {reduxForm} from 'redux-form'

import {validateSepa as validate} from '../../util/validate'

class SepaForm extends Component {


    static propTypes = {
        forceValidation: PropTypes.bool
    }

    static defaultProps = {
        forceValidation: false
    }


    shouldComponentUpdate(nextProps, nextState) {

        if (this.props.forceValidation !== nextProps.forceValidation) {
            return true
        }

        return false

    }

    render() {
        return (

            <form className="payment-step__sepa-input">
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="accountHolder" label="Kontoinhaber" placeholder="Vorname Nachname"/>
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="iban" label="IBAN" placeholder="z.B. DE 12 5001 0517 0648 4898 90"/>
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="bic" label="BIC" placeholder="z.B. DEUT DE D8 XXX"/>
            </form>

        )
    }
}


export default reduxForm({form: 'sepaPayment', destroyOnUnmount: false, validate})(SepaForm)


/** WEBPACK FOOTER **
 ** ./src/containers/payment/SepaForm.js
 **/